<template>
    <div class="two-factor-authentication-page">
        <div :class="{'two-factor-authentication-page__header': show}">
            <logos-container-ui center class="mt-3 two-factor-authentication-page__logo" />
            <span
            class="fas fa-times two-factor-authentication-page__close-button" 
            @click="handleCancel"
            aria-label="Cancel"
            title="Cancel"
            />
        </div>
        <div >
            <h1 class="two-factor-authentication-page__title">
                {{ $t('Two-Factor Authentication') }}
            </h1>
        </div>
        <div class="two-factor-authentication-page__content">
            <qr-code @success="verificationStatus" v-if="!showVerificationSuccess"/>
            <div v-if="showVerificationSuccess">
                <ui-empty-state img-size="sm" img="verification-check.svg" :title="$t('Successfully activated')" :text="$t('Two-step verification is active.')" class="two-factor-authentication-page__empty-state" />
                <ui-button @click="redirect" class="w-50">
                    {{ $t('Continue') }}
                </ui-button>
            </div>
        </div>
    </div>
</template>

<script>
import UiEmptyState from '@/components/ui/EmptyState.vue';
import ActivateForm from '@/components/twofactorauth/ActivateForm.vue';
import QrCode from '@/components/twofactorauth/QrCode.vue';
import LogosContainerUi from '@/components/ui/LogosContainer.vue'
import UiButton from '@/components/ui/buttons/Button.vue';


export default {
    name: 'two-factor-authentication-page',
    components: {
        ActivateForm,
        QrCode,
        LogosContainerUi,
        UiEmptyState,
        UiButton
    },
    data() {
        return {
            show: false,
            showVerificationSuccess: false
        }
    },
    methods: {
        showQRCode(value) {
            if (value) {
                this.show = true;
                return;
            }
            this.redirect();
        },
        redirect() {
            const { redirect_url } = this.$route.query;
            if (redirect_url) {
                window.location.replace(redirect_url);
                return;
            }
            this.$router.push({ name: 'dashboard'})
        },
        handleCancel() {
            this.$router.go(-1);
        },
        verificationStatus() {
            this.showVerificationSuccess = true;
            this.show = false;
        }
    }
};
</script>

<style lang="scss">
.two-factor-authentication-page {
    text-align: center;
    position: relative;

     &__header {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 24px;
        position: relative;
    }

    &__logo {
        width: 100%;
        height: auto;
    }

    &__close-button {
        position: absolute;
        right: 20px;
        top: 20px;
        cursor: pointer;
        font-size: 24px;
        color: #000652;
    }

    &__title {
        font-size: 36px;
        line-height: 43.88px;
        align-items: center;
        font-weight: 600;
        margin: 24px !important;
        color: #404042;

        @media (max-width: 768px) {
            margin: 16px !important;
        }
    }

    &__empty-state {
        padding: 24px;

        @media (max-width: 768px) {
            padding: 16px;
        }
    }
}
</style>